import { emailApi } from '../../api';
import {
  EmailTestRequest,
  UpdateEmailConfiguration,
} from '../../types/email/EmailTypes';

const EmailConfigService = {
  getConfiguration: async () => {
    const response = await emailApi.fetchCustom('/configuration');
    return response.data;
  },

  saveOrUpdate: async (data: UpdateEmailConfiguration) => {
    const response = await emailApi.modifyCustom('/configuration', data);
    return response.data;
  },

  sendTestEmail: async (data: EmailTestRequest) => {
    const response = await emailApi.addCustom('/test', data);
    return response.data;
  },
};

export default EmailConfigService;
